import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW9004Model } from '../kymw9004.model';
import { AuthoritySetInformationDetailModel } from '../vo/authority-set-infomation-detail.model';
import { GetAuthoritySetDetailService } from './get-authority-set-detail.service';

/**
 * ユーザ権限情報の登録を行う。
 *
 * @export API通信成功時の処理
 * @class RegistAuthoritySetService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistAuthoritySetService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9004Model;
  private successFunc: Function;
  private vo: AuthoritySetInformationDetailModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistAuthoritySetService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        registAuthoritySet: {
          parameter: {
            AuthoritySetName: this.vo.authoritySetName,
            AdminDiv: this.vo.adminDiv,
            AuthoritySetExplanation: this.vo.authoritySetExplanation,
            AuthorityStatus: this.vo.authorityStatus,
          },
          combination: this.vo.funcAuthorityList == null ? [] : this.vo.funcAuthorityList.map(regist =>{
            return{
              parameter: {
                FuncId: regist.FuncId,
                EnableMode: regist.EnableMode,
              }
            }
          })          
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {AuthoritySetInformationDetailModel} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof RegistAuthoritySetService
   */
  execute(model: KYMW9004Model, vo: AuthoritySetInformationDetailModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registAuthoritySet', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistAuthoritySetService
   */
  success(data: any) {
    this.dialogService.openAlertGetMessage('I0504', ['権限設定']);
    if ( this.successFunc !== null ) {
      this.successFunc(data);
    }
  }
}
